import axios, { type CancelToken } from "axios";
import urlJoin from "url-join";
import type { BaseParams } from "../../../client.types.js";
import type { IGetAffiliationErrorsResponse200 } from "../../../routes/private/AffiliationErrors/GetAffiliationErrors/GetAffiliationErrors.interfaces.js";
import type { GetAffiliationErrors } from "./getAffiliationErrors.types.js";

export type { IGetAffiliationErrorsResponse200 };
export const getAffiliationErrors =
    ({
        baseUrl,
        headers,
        httpAgent,
        httpsAgent,
        adapter,
    }: BaseParams): GetAffiliationErrors extends (...args: infer P) => infer R
        ? P extends []
            ? (params?: { cancelToken?: CancelToken }) => R
            : (
                  params: P[0] & {
                      cancelToken?: CancelToken;
                  },
              ) => R
        : never =>
    async (params) => {
        try {
            const url = urlJoin(baseUrl, `/affiliation-errors`);
            const result = await axios.get<IGetAffiliationErrorsResponse200>(url, {
                httpsAgent,
                httpAgent,
                headers,
                adapter,
                cancelToken: params?.cancelToken,
            });
            return { hasFailed: false, status: result.status, data: result.data };
        } catch (e: any) {
            if (axios.isAxiosError(e)) {
                if (e.response !== undefined) {
                    return {
                        hasFailed: true,
                        status: e.response.status,
                        error: {
                            code:
                                typeof e.response?.data?.code === "string" || typeof e.response?.data?.code === "number"
                                    ? String(e.response.data.code)
                                    : "UNKNOWN_ERROR",
                            message:
                                typeof e.response?.data?.message === "string"
                                    ? e.response.data.message
                                    : typeof e.response?.data === "string"
                                      ? e.response.data
                                      : "Unknown error",
                            raw: e.response.data,
                        },
                    };
                }
                if (e.request !== undefined) {
                    return {
                        hasFailed: true,
                        status: 503,
                        error: {
                            code: "SERVICE_UNAVAILABLE",
                            message: "Service unavailable",
                            raw: e.request,
                        },
                    };
                }
            }
            return {
                hasFailed: true,
                status: 500,
                error: {
                    code: "UNKNOWN_ERROR",
                    message: typeof e === "string" ? e : e instanceof Error ? e.message : "Unknown error",
                },
            };
        }
    };
